import React from "react";

export default function CardSample(props) {
  return <div></div>;
}
